export var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["CONNECTED"] = "connected";
    ConnectionStatus["DISCONNECTED"] = "disconnected";
})(ConnectionStatus || (ConnectionStatus = {}));
//# sourceMappingURL=connectionStatus.js.map